import { adsMidBlueB } from "../utils/ADSColours";

const BLPUState = [
  {
    id: 0,
    gpText: "Not Applicable",
    osText: "not applicable",
    colour: adsMidBlueB,
    default: false,
  },
  {
    id: 1,
    gpText: "Under construction",
    osText: "under construction / named or numbered by SNN",
    colour: adsMidBlueB,
    default: true,
  },
  {
    id: 2,
    gpText: "Complete",
    osText: "constructed",
    colour: adsMidBlueB,
    default: true,
  },
  {
    id: 3,
    gpText: "Unoccupied / unusable / derelict",
    osText: "derelict / vacant",
    colour: adsMidBlueB,
    default: false,
  },
  {
    id: 4,
    gpText: "No Longer Existing",
    osText: "no longer existing",
    colour: adsMidBlueB,
    default: false,
  },
  {
    id: 5,
    gpText: "Planning Application Received (Internal)",
    osText: "Planning Application Received (Internal)",
    colour: adsMidBlueB,
    default: false,
  },
  {
    id: 6,
    gpText: "Preconstruction",
    osText: undefined,
    colour: adsMidBlueB,
    default: true,
  },
  {
    id: 7,
    gpText: "Planning Permission Refused (Internal)",
    osText: "Planning Permission Refused (Internal)",
    colour: adsMidBlueB,
    default: false,
  },
];

export default BLPUState;
